import { memo, useMemo } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../@types/RootState';
import { selectorUser } from '../../../lib/selectorUser';
import { selectorNavBarData } from '../../../reducers/navBar/data';
import styles from './NavBarContentText.module.scss';

type NavBarContentTextProps = ReturnType<typeof mapStateToProps>;

const NavBarContentText = ({ navBar, user }: NavBarContentTextProps) => {
  const userPlanType = useMemo(() => {
    return user?.servicoPanelCliente?.pacotePainel?.description;
  }, [user]);

  const isInfoPanelService = useMemo(() => {
    return navBar?.label === 'InfoPanel';
  }, [navBar?.label]);

  if (!navBar) return null;

  if (!navBar.panel) {
    return (
      <div className={styles['wrapper']}>
        <h2 className={styles['active-menu']}>{navBar.label}</h2>
      </div>
    );
  }

  return (
    <div className={styles['wrapper']}>
      <h2 className={styles['active-menu']}>{`${navBar.panel} | ${navBar.label}`}</h2>
      {isInfoPanelService && <span className={styles['badge']}>{userPlanType}</span>}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  navBar: selectorNavBarData(state),
  user: selectorUser(state),
});

export default memo(connect(mapStateToProps)(NavBarContentText));
